import { generateSasUriToken } from "../components/action";
import { buildMusicBlobUrl, getSasTokenForBlobAccess } from "./musicExport";

/** Overwrites an existing blob at pdfsimpliusers/{relativePath}. */
export async function overwriteMusicBlob(
  relativePath: string,
  blob: Blob,
  contentType = "audio/wav",
): Promise<void> {
  const normalized = relativePath.replace(/^pdfsimpliusers\//, "");
  const sasToken =
    (await generateSasUriToken().catch(() => null)) ??
    (await getSasTokenForBlobAccess());
  const url = buildMusicBlobUrl(normalized, sasToken);

  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "x-ms-blob-type": "BlockBlob",
      "Content-Type": contentType,
    },
    body: blob,
  });

  if (!response.ok) {
    const detail = await response.text().catch(() => "");
    throw new Error(
      `Failed to save equalized audio to blob storage (${response.status})${detail ? `: ${detail}` : ""}`,
    );
  }
}
